module.exports = __webpack_public_path__ + "static/media/squared.4edb9410.jpg";